import {
  ADD_SCREEN,
  DELETE_SCREEN,
  GET_SCREEN,
  UPDATE_SCREEN,
  GET_ONE_SCREEN
} from '../types';

// const initialState = { list: [], single: null };
const initialState = {
  list: [],
  pagination: {
    limit: 10,
    nextPage: null,
    totalPages: 1,
    currentPage: 1,
    hasNextPage: false,
    previousPage: null,
    totalProducts: 0,
    hasPreviousPage: false,
  },
  single: null
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SCREEN:
      return { ...state, list: payload, pagination: payload.pagination };

    case UPDATE_SCREEN:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case ADD_SCREEN:
      return {
        ...state,
        list: [payload, ...state.list],
      };

    case DELETE_SCREEN:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };
    case GET_ONE_SCREEN:
      return { ...state, single: payload };

    default:
      return state;
  }
};

export default reducer;
